import React from 'react';

export const BookingSvg: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={20}
            height={20}
            viewBox="0 0 32 32"
        >
            <g>
                <g data-name="Layer 2">
                    <path
                        d="M27 4h-4V3a1 1 0 0 0-2 0v1H11V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v20a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM5 6h22a1 1 0 0 1 1 1v3H4V7a1 1 0 0 1 1-1zm22 22H5a1 1 0 0 1-1-1V12h24v15a1 1 0 0 1-1 1z"
                        fill="#000000"
                    />
                    <path
                        d="m20.35 15.241-6.3 5.4-2.346-2.345a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.357.052l7-6a1 1 0 1 0-1.3-1.518z"
                        fill="#000000"
                    />
                </g>
            </g>
        </svg>
    );
};
